export default "__VITE_ASSET__C0dINXD2__"